import { Component } from "react";

class RadioButton extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }
  render() { 
    return ( <div className="flex gap-2 items-center">
      <input type="radio" name={this.props.group} id={this.props.name} value={this.props.name} checked={this.props.checked} className="w-4 h-4 accent-khaki-default"/>
      <label htmlFor={this.props.name}>{this.props.label}</label>
    </div> );
  }
}
 
export default RadioButton;